
import { INhapKhoActions } from "../../action-types/category/INhapKhoActionTypes";
import { INhapKhoReducer } from "../../reducer-model/category/INhapKhoReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: INhapKhoReducer = {
    status: eReducerStatusBase.is_not_initialization,
    nhapKhos: []
}
export const nhapKhoReducer = (state: INhapKhoReducer = iniState, action: INhapKhoActions): INhapKhoReducer => {
    switch (action.type) {
        case "NHAP_KHO_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "NHAP_KHO_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                nhapKhos: action.payload
            }
        case "NHAP_KHO_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "NHAP_KHO_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                nhapKhoEditing: action.payload
            }
        case "NHAP_KHO_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "NHAP_KHO_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "NHAP_KHO_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            }
        case "NHAP_KHO_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "NHAP_KHO_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "NHAP_KHO_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "NHAP_KHO_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "NHAP_KHO_SHOW_IMPORT_MODAL":
            return {
                ...state,
                isShowImportModal: true,
            }
        case "NHAP_KHO_CLOSE_IMPORT_MODAL":
            return {
                ...state,
                isShowImportModal: false,
            }
        case "NHAP_KHO_SAVE_IMPORT_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "NHAP_KHO_SAVE_IMPORT_SUCCESS":
            return {
                ...state,
                isShowImportModal: false,
                status: eReducerStatusBase.is_need_reload
            }
        case "NHAP_KHO_SAVE_IMPORT_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        default:
            return state;
    }
}